import React from 'react'
import Common from './Common'
import rocket from './images/rocket.png'

function About() {
  return (
    <>
        <Common 
        name= 'Welcome To About Page'
        imgsrc={rocket} 
        visit ='/contact'
        btName = "Contact Now" 
        />
    </>
  )
}

export default About
